// import React from "react";
// import SideBar from "./components/sidebar";
// import ProfileInfo from "./components/ProfileInfo";

// function Me() {
//   return (
//     <div dir="rtl" className="flex flex-col lg:flex-row mt-10 mx-4 lg:mx-12">
//       {/* Main content */}
//       <div className="w-full">
//         <div className="w-full border shadow-2xl rounded-2xl p-6 lg:p-8 mb-6">
//           <ProfileInfo />
//         </div>

//         {/* Placeholder for future sections like orders/messages */}
//         <div className="w-full grad border border-gray-200 rounded-2xl p-6 shadow-xl">
//           <h3 className="text-lg font-semibold mb-2">أنشطتك الأخيرة</h3>
//           <p className="text-sm text-white">سيتم عرض الطلبات والرسائل الأخيرة هنا قريبًا.</p>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Me;
import React from "react";
import { useTranslation } from "react-i18next";
import SideBar from "./components/sidebar";
import ProfileInfo from "./components/ProfileInfo";

function Me() {
  const { t, i18n } = useTranslation();

  return (
    <div dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} className="flex flex-col lg:flex-row mt-10 mx-4 lg:mx-12">
      {/* Main content */}
      <div className="w-full">
        <div className="w-full border shadow-2xl rounded-2xl p-6 lg:p-8 mb-6">
          <ProfileInfo />
        </div>

        {/* Placeholder for future sections like orders/messages */}
        <div className="w-full grad border border-gray-200 rounded-2xl p-6 shadow-xl">
          <h3 className="text-lg font-semibold mb-2">{t("profile.recentActivity")}</h3>
          <p className="text-sm text-white">{t("profile.recentActivityPlaceholder")}</p>
        </div>
      </div>
    </div>
  );
}

export default Me;